import { render, staticRenderFns } from "./WorkTypeCategoryModal.vue?vue&type=template&id=25726a4d&"
import script from "./WorkTypeCategoryModal.vue?vue&type=script&lang=js&"
export * from "./WorkTypeCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports